import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import * as FaIcons from "react-icons/fa";
import * as AiIcons from "react-icons/ai";
import { SidebarData, SidebarDatafalse, SidebarDataAdmin } from './SidebarData'
import './Navbar.css'
import { IconContext } from 'react-icons'
import logo from './img/logo.png'
import Footer from './Footer';
import { isADM } from '../pages/isADM'
import {useAuth} from "../services/auth";


//Create a function that will check if the user is loged

const PrivateMenuItems = isADM ? SidebarDataAdmin.map((item, index) => {
    return (
        <li key={index} className={item.cName}>
            {
                <Link to={item.path}>
                    {item.icon}
                    <span>{item.title}</span>
                </Link>
            }
        </li>
    );
})
    :
    SidebarData.map((item, index) => {
        return (
            <li key={index} className={item.cName}>
                {
                    <Link to={item.path}>
                        {item.icon}
                        <span>{item.title}</span>
                    </Link>
                }
            </li>
        );
    })


const PublicMenuItems = SidebarDatafalse.map((item, index) => {
    return (
        <li key={index} className={item.cName}>
            {
                <Link to={item.path}>
                    {item.icon}
                    <span>{item.title}</span>
                </Link>
            }
        </li>
    );
})


function Navbar() {
    const {isLogged} = useAuth();
    const [sidebar, setSidebar] = useState(false)

    const showSidebar = () => setSidebar(!sidebar)
    
    return (
        <>
            <IconContext.Provider value={{ color: 'white' }}>
                <div className="navbar">

                    <Link to="#" className='menu-bars'>

                        <FaIcons.FaBars onClick={showSidebar} />
                    </Link>
                    <h3 className="Title">B-Wise Manager</h3>
                    <img src={logo} alt="Logo" className="Logo" />
                </div>
                <nav className={sidebar ? 'nav-menu active' : 'nav-menu'}>
                    <ul className='nav-menu-items' onClick={showSidebar}>
                        <li className="navbar-toggle" key={-1}>
                            <Link to="#" className='menu-bars'>
                                <AiIcons.AiOutlineClose />
                            </Link>
                        </li>
                        {isLogged ? PrivateMenuItems : PublicMenuItems}
                    </ul>
                </nav>
            </IconContext.Provider>
            <footer>
                <Footer></Footer>
            </footer>
        </>
    );
}
export default Navbar;